<template>
  <section
    v-if="recommandations && recommandations.length != 0"
    class="reco-wrapper"
    :class="[{ thankYouPage: isThankYou }, type]"
  >
    <h4 class="recommanded-title">{{ recommendedTitle }}</h4>
    <ul id="recommended" class="list-unstyled">
      <a
        v-for="(r, index) in recommandations"
        :key="index"
        class="media"
        :href="itemLink(r.item_id)"
      >
        <img :src="r.img" />
        <div class="content-wrapper">
          <div class="rec-title" v-if="type != 'news'">{{ r.title }}</div>
          <div class="rec-text" v-if="showText">{{ r.text }}</div>
        </div>
      </a>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RecommandedItems",
  props: ["recommandations", "type", "isThankYou"],
  computed: {
    ...mapGetters(["t"]),
    recommendedTitle: function() {
      let visualTitle;
      if (this.type === "ebook") {
        visualTitle = "Recommended_ebook_label";
      }
      if (this.type === "news") {
        visualTitle = "Recommended_news_label";
      }
      if (this.type === "videos") {
        visualTitle = "Recommended_Videos_label";
      }
      if (this.type === "webinars") {
        visualTitle = "Recommended_webinars_label";
      }
      return this.t(visualTitle);
    },
    showText: function() {
      if (
        window.matchMedia("(max-width: 768px)").matches &&
        this.type == "videos"
      ) {
        return false;
      }
      return true;
    }
  },

  methods: {
    itemLink: function(item_id) {
      let redirectPath;
      if (!this.isThankYou) {
        redirectPath =
          location.href.slice(0, location.href.lastIndexOf("/")) +
          "/" +
          item_id;
      } else {
        const abovePath = location.href.slice(
          0,
          location.href.lastIndexOf("/")
        );
        redirectPath =
          abovePath.slice(0, abovePath.lastIndexOf("/")) + "/" + item_id;
      }
      return redirectPath;
    }
  }
};
</script>

<style lang="scss" scoped>
.temporary-video {
  width: 35%;
  height: 65px; //temp for img placeholder div
  background: gray;
}

.media {
  height: 65px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.media:hover {
  cursor: pointer;
}

.ebook {
  .recommanded-title {
    margin-bottom: 40px;
  }
  .media {
    height: unset;
    min-height: 145px;
    margin-top: unset;
    margin-bottom: 34px;

    .temporary-video {
      height: 165px; //temp for img placeholder div
      width: 30%;
    }

    .content-wrapper {
      max-width: calc(70% - 20px);
    }

    .content-wrapper .rec-title {
      font-weight: bold;
      margin-bottom: 12px;
    }

    .content-wrapper .rec-text {
      color: #4a4a4a;
    }
  }
}

.news {
  .content-wrapper .rec-text {
    color: #424242;
    font-weight: 500;
  }
}

.content-wrapper {
  margin-left: 20px;
  max-width: calc(65% - 20px);
}

.content-wrapper .rec-title {
  margin-bottom: 6px;
  color: #424242;
  font-size: 14px;
  font-weight: 500;
}

.content-wrapper .rec-text {
  color: #9e9e9e;
  font-size: 14px;
}

.recommanded-title {
  font-size: 1.25rem;
  margin-bottom: 1.5rem;
  font-weight: normal;
}

.reco-wrapper:not(.ebook) a img {
  width: 109px;
  height: 65px;
}

.reco-wrapper.ebook a img {
  width: 94px;
}

.ar {
  .content-wrapper {
    margin: 0 20px 0 0;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1200px) {
  .content-wrapper {
    margin-left: 10px;
    max-width: calc(65% - 10px);
    line-height: normal;
  }

  .content-wrapper .rec-title {
    margin-bottom: 2px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 920px) {
  .content-wrapper .rec-title {
    font-size: 0.75rem;
  }
  .content-wrapper .rec-text {
    font-size: 0.75rem;
  }
}

@media only screen and (min-width: 768px) {
  .content-wrapper .rec-title {
    line-height: 1.25rem;
  }

  .content-wrapper .rec-text {
    line-height: 1.125rem;
  }
  .thankYouPage {
    &.webinars {
      .recommanded-title {
        margin-bottom: 1rem;
      }
    }
    &.ebook {
      .recommanded-title {
        margin-bottom: 2rem;
      }
    }
    .recommanded-title {
      font-size: 1.5rem;
      line-height: 34px;
    }
    #recommended {
      display: flex;
      .media {
        width: 33%;
        padding-right: 12px;
        &:last-of-type {
          padding-right: 0;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  #recommended {
    padding-right: 16px;
    padding-left: 16px;
  }
  .recommanded-title {
    font-size: 16px;
    line-height: 48px;
    background-color: #f6f6f6;
    width: 100%;
    padding: 0 16px;
    margin-bottom: 0;
  }

  .reco-wrapper:not(.ebook):not(.news) {
    .media {
      flex-direction: column;
      align-items: center;
      border: 1px solid #d5d3d3;
      display: inline-block;
      height: auto;
      margin-bottom: 0 !important;
      width: 100%;
    }

    .temporary-video {
      width: 100%;
      height: 184px;
      margin-bottom: 8px;
    }

    .content-wrapper {
      max-width: none;
      margin-left: auto;
      margin-right: auto;
      padding: 1rem;
      .rec-title {
        font-size: 1rem;
        margin-bottom: unset;
      }
    }

    .content-wrapper .rec-text {
      font-size: 17px;
    }

    a img {
      width: 100%;
      height: 100%;
    }
  }

  .reco-wrapper.webinars {
    a.media {
      .content-wrapper {
        .rec-title {
          margin-bottom: 0.75rem;
        }
      }
      img {
        height: 183px;
      }
    }
  }

  .ebook {
    .recommanded-title {
      margin-bottom: 14px;
    }
    #recommended {
      padding-right: 10px;
      padding-left: 10px;
      .rec-title {
        font-size: 1.125rem;
      }
    }
  }
  .videos {
    #recommended {
      margin-bottom: 1.125rem;
    }
  }
}
</style>
